import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import "../Personal/Personal.scss";
import SoftButton from "StyleFeatures/SoftButton";
import { ToastContainer, toast } from "react-toastify";
import choosefile from "assets/images/uploadfile.png";
import Footer from "Common/Footer";
import { Card } from "antd";

function PersonalInfoInvited({ onNext, initialData = {} }) {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    mobileNo: "",
    gender: "",
    maritalStatus: "",
    streetAddress: "",
    city: "",
    state: "",
    postalCode: "",
    country: "",
    image: null,
  });

  const [errors, setErrors] = useState({});
  const [selectedImage, setSelectedImage] = useState(null);

  useEffect(() => {
    if (initialData && Object.keys(initialData).length > 0) {
      setFormData(initialData);
      if (initialData.image && typeof initialData.image === "string") {
        setSelectedImage(initialData.image);
      }
    }
  }, [initialData]);

  // ========================
  // Handle Input Change
  // ========================
  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    // clear error on typing
    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  // ========================
  // Image Upload
  // ========================
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedImage(URL.createObjectURL(file));
      setFormData((prev) => ({
        ...prev,
        image: file,
      }));

      setErrors((prev) => ({
        ...prev,
        image: "",
      }));
    }
  };

  const handleImageClick = () => {
    document.getElementById("fileInput").click();
  };

  // ========================
  // Validation
  // ========================
  const validate = () => {
    let newErrors = {};

    if (!formData.image) newErrors.image = "Required";
    if (!formData.firstName) newErrors.firstName = "Required";
    if (!formData.lastName) newErrors.lastName = "Required";
    if (!formData.mobileNo) newErrors.mobileNo = "Required";
    if (!formData.gender) newErrors.gender = "Required";
    if (!formData.maritalStatus) newErrors.maritalStatus = "Required";
    if (!formData.streetAddress) newErrors.streetAddress = "Required";
    if (!formData.city) newErrors.city = "Required";
    if (!formData.state) newErrors.state = "Required";
    if (!formData.postalCode) newErrors.postalCode = "Required";
    if (!formData.country) newErrors.country = "Required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleNext = () => {
  if (!validate()) {
    toast.error("Please fill all required fields");
    return;
  }

  onNext(formData);
};

  return (
    <div className="body flex-grow-1 px-3">
      <Card title="Personal Info" className="card-professional">
        <form
          onSubmit={(e) => {
            e.preventDefault();
            handleNext();
          }}
        >
          <ToastContainer />

          {/* IMAGE */}
          <div className="mb-3">
            <label>Upload Image *</label>
            <br />

            <img
              src={selectedImage || choosefile}
              alt="avatar"
              onClick={handleImageClick}
              style={{
                height: "100px",
                width: "100px",
                cursor: "pointer",
                borderRadius: "50%",
                border: `2px dashed ${errors.image ? "red" : "#ccc"}`,
              }}
            />

            <input
              type="file"
              id="fileInput"
              hidden
              onChange={handleFileChange}
            />

            {errors.image && (
              <div style={{ color: "red", fontSize: "13px" }}>
                {errors.image}
              </div>
            )}
          </div>

          {/* FIELDS */}
          <div className="row">
            <div className="col-md-6">
              <input
                name="firstName"
                placeholder="First Name"
                className={`form-control mb-2 ${errors.firstName ? "is-invalid" : ""}`}
                onChange={handleChange}
                value={formData.firstName}
              />
              {errors.firstName && (
                <div className="invalid-feedback">{errors.firstName}</div>
              )}
            </div>

            <div className="col-md-6">
              <input
                name="lastName"
                placeholder="Last Name"
                className={`form-control mb-2 ${errors.lastName ? "is-invalid" : ""}`}
                onChange={handleChange}
                value={formData.lastName}
              />
              {errors.lastName && (
                <div className="invalid-feedback">{errors.lastName}</div>
              )}
            </div>

            <div className="col-md-6">
              <input
                name="mobileNo"
                placeholder="Mobile No"
                className={`form-control mb-2 ${errors.mobileNo ? "is-invalid" : ""}`}
                onChange={handleChange}
                value={formData.mobileNo}
              />
              {errors.mobileNo && (
                <div className="invalid-feedback">{errors.mobileNo}</div>
              )}
            </div>

            <div className="col-md-6">
              <select
                name="gender"
                className={`form-control mb-2 ${errors.gender ? "is-invalid" : ""}`}
                onChange={handleChange}
                value={formData.gender}
              >
                <option value="">Select Gender</option>
                <option value="Male">Male</option>
                <option value="Female">Female</option>
              </select>
              {errors.gender && (
                <div className="invalid-feedback">{errors.gender}</div>
              )}
            </div>

            <div className="col-md-6">
              <select
                name="maritalStatus"
                className={`form-control mb-2 ${errors.maritalStatus ? "is-invalid" : ""}`}
                onChange={handleChange}
                value={formData.maritalStatus}
              >
                <option value="">Marital Status</option>
                <option value="Single">Single</option>
                <option value="Married">Married</option>
              </select>
              {errors.maritalStatus && (
                <div className="invalid-feedback">{errors.maritalStatus}</div>
              )}
            </div>

            <div className="col-md-12">
              <input
                name="streetAddress"
                placeholder="Street Address"
                className={`form-control mb-2 ${errors.streetAddress ? "is-invalid" : ""}`}
                onChange={handleChange}
                value={formData.streetAddress}
              />
              {errors.streetAddress && (
                <div className="invalid-feedback">{errors.streetAddress}</div>
              )}
            </div>

            <div className="col-md-4">
              <input
                name="city"
                placeholder="City"
                className={`form-control mb-2 ${errors.city ? "is-invalid" : ""}`}
                onChange={handleChange}
                value={formData.city}
              />
              {errors.city && (
                <div className="invalid-feedback">{errors.city}</div>
              )}
            </div>

            <div className="col-md-4">
              <input
                name="state"
                placeholder="State"
                className={`form-control mb-2 ${errors.state ? "is-invalid" : ""}`}
                onChange={handleChange}
                value={formData.state}
              />
              {errors.state && (
                <div className="invalid-feedback">{errors.state}</div>
              )}
            </div>

            <div className="col-md-4">
              <input
                name="postalCode"
                placeholder="Postal Code"
                className={`form-control mb-2 ${errors.postalCode ? "is-invalid" : ""}`}
                onChange={handleChange}
                value={formData.postalCode}
              />
              {errors.postalCode && (
                <div className="invalid-feedback">{errors.postalCode}</div>
              )}
            </div>

            <div className="col-md-12">
              <input
                name="country"
                placeholder="Country"
                className={`form-control mb-2 ${errors.country ? "is-invalid" : ""}`}
                onChange={handleChange}
                value={formData.country}
              />
              {errors.country && (
                <div className="invalid-feedback">{errors.country}</div>
              )}
            </div>
          </div>

          <SoftButton
            variant="outlined"
            className="btn-primary"
            size="small"
            type="submit"
            style={{ float: "right" }}
          >
            Next
          </SoftButton>
        </form>
      </Card>
      <Footer />
    </div>
  );
}

PersonalInfoInvited.propTypes = {
  onNext: PropTypes.func.isRequired,
  initialData: PropTypes.object,
};

export default PersonalInfoInvited;